import React, { useState } from 'react';
import {
    Box,
    Container,
    Paper,
    Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { usePermission } from '../../hooks/usePermission';
import DivisionForm from '../../Components/Divisions/DivisionForm';
import DivisionTable from '../../Components/Divisions/DivisionTable';
import { CreateDivisionsPermission } from '../../constants/permissions';

const Divisions = () => {
    const { data: canCreateDivision } = usePermission({
        permissionName: CreateDivisionsPermission
    });

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        acronym: '',
        description: '',
    });

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setFormData({
            name: '',
            acronym: '',
            description: '',
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <Container maxWidth="xl">
            <Box sx={{ py: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
                    <Typography variant="h4" component="h1">
                        Divisions
                    </Typography>
                    {canCreateDivision && (
                        <button
                            className='bg-blueColor text-white rounded-md px-4 py-2 flex items-center gap-2'
                            onClick={handleClickOpen}
                        >
                            <AddIcon />
                            Add New Division
                        </button>
                    )}
                </Box>

                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                    <DivisionTable />
                </Paper>

                <DivisionForm
                    open={open}
                    onClose={handleClose}
                    formData={formData}
                    onInputChange={handleInputChange}
                />
            </Box>
        </Container>
    );
};

export default Divisions; 